import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../../theme/cards/BaseCard"
import { tokens } from "../../../../../theme";
import Text from "../../../../theme/text/Text";
import CardLabel from "../../../../theme/label/CardLabel";
import TopRight from "../../../../theme/positionals/TopRight";

import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import HorizontalRuleOutlinedIcon from '@mui/icons-material/HorizontalRuleOutlined';
import { useTranslation } from "react-i18next";
import ShTextSkeleton from "../../../../theme/skeleton/ShTextSkeleton";
import { hexToRgb } from "../../../../../utils/colorConverters";

const AllCarriersCard = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);

    return (
        <BaseCard onClick={props.onClick}>
            <Box>
                <Box>
                    <Box display={"flex"} flexDirection={"column"}>
                        <Text bold>{props.name}</Text>
                    </Box>
                    <TopRight>
                        {
                            props.fitsPost || props.fitsPost === "true" ?
                                <CardLabel variant="green" icon><CheckOutlinedIcon fontSize="small"/></CardLabel>:
                            !props.fitsPost || props.fitsPost === "false" ?
                                <CardLabel variant="red" icon><CloseOutlinedIcon fontSize="Small" /></CardLabel> 
                            :
                                <CardLabel variant="orange" icon><HorizontalRuleOutlinedIcon fontSize="Small"/></CardLabel>
                        }
                        {/* <CardLabel variant="red"  position="child-tr">X</CardLabel> */}
                    </TopRight>


                    {/* Holds tht date and batch */}
                    <Box marginTop={3} display={"flex"} alignItems={"flex-end"} justifyContent={"space-between"} gap={4}>

                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("dimensions_lwh")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/> 
                                :
                                <>
                                    <Text>
                                        {`${props.length}mm x ${props.width}mm x ${props.height}mm`} <b>({props.weight} {t("gram")})</b>
                                    </Text>
                                </>
                            }
                        </Box>
                        {props.color && (() => {
                            let rgb = []
                            const parsed = JSON.parse(props.color);
                            if(parsed && parsed.hex){
                                rgb = hexToRgb(parsed.hex);
                            }
                            return (
                                <Box
                                    sx={{
                                        display:"flex",
                                        alignItems:"center",
                                        borderRadius:7,
                                        height:32,
                                        px:0.5,
                                        background: `linear-gradient(rgba(${rgb?.[0] ?? '255'}, ${rgb?.[1]?? '255'}, ${rgb?.[2]?? '255'},1), rgba(${rgb?.[0]?? '255'}, ${rgb?.[1]?? '255'}, ${rgb?.[2]?? '255'},1)), ${theme.palette.mode === "dark" ? "black" : "white"}`, /* Solid white background */
                                        width:70,
                                    }}
                                >
                                </Box>
                            );
                        })()}

                        {/* <Box display={"flex"} flexDirection={"column"}>
                            <Text light>Weight</Text>
                            <Text bold>{props.weight}</Text>
                        </Box>
                        <Box display={"flex"} flexDirection={"column"}>
                            <Text light>Channels</Text>
                            <Text bold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{props.channels}</Text>
                        </Box>
                        <Box display={"flex"} flexDirection={"column"}>
                            <Text light># Barcodes</Text>
                            <Text bold>{props.barcodes}</Text>
                        </Box> */}
                    </Box>
                </Box>
            </Box>
        </BaseCard>
    )
}

export default AllCarriersCard;